module.exports = __webpack_public_path__ + "static/feather-3-4d57596f05df2bb41b8260ef58d66d91.png";